const requiredUpdatesRedirects = {
	email: "/validar-contato/email",
	email_expired: "/atualizar-contato/email",
	phone_expired: "/atualizar-contato/telefone",
	password: "/unificar-senha",
} as { [key: string]: string };

export default requiredUpdatesRedirects;
